import { render, staticRenderFns } from "./settings-toggle.vue?vue&type=template&id=050dcac9"
import script from "./settings-toggle.vue?vue&type=script&lang=js"
export * from "./settings-toggle.vue?vue&type=script&lang=js"
import style0 from "./settings-toggle.vue?vue&type=style&index=0&id=050dcac9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports